const AppliedPromoIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_941_358)">
			<path
				d="M5.55469 6.389C5.55469 6.61001 5.64249 6.82197 5.79877 6.97825C5.95505 7.13453 6.16701 7.22233 6.38802 7.22233C6.60903 7.22233 6.821 7.13453 6.97728 6.97825C7.13356 6.82197 7.22135 6.61001 7.22135 6.389C7.22135 6.16798 7.13356 5.95602 6.97728 5.79974C6.821 5.64346 6.60903 5.55566 6.38802 5.55566C6.16701 5.55566 5.95505 5.64346 5.79877 5.79974C5.64249 5.95602 5.55469 6.16798 5.55469 6.389Z"
				stroke="#8F949B"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 5V9.31C2.50009 9.75199 2.67575 10.1758 2.98833 10.4883L9.41333 16.9133C9.78996 17.2899 10.3007 17.5015 10.8333 17.5015C11.3659 17.5015 11.8767 17.2899 12.2533 16.9133L16.9133 12.2533C17.2899 11.8767 17.5015 11.3659 17.5015 10.8333C17.5015 10.3007 17.2899 9.78996 16.9133 9.41333L10.4883 2.98833C10.1758 2.67575 9.75199 2.50009 9.31 2.5H5C4.33696 2.5 3.70107 2.76339 3.23223 3.23223C2.76339 3.70107 2.5 4.33696 2.5 5Z"
				stroke="#8F949B"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_941_358">
				<rect
					width="20"
					height="20"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default AppliedPromoIcon;
